export enum AuthStorage {
	userPolicy = "user-policy-resolv-risk-plataform",
	userInformation = "user-info-resolv-risk-plataform",
	userToken = "user-token-resolv-risk-plataform",
	userAuthorization = "user-authorization-token-resolv-risk-plataform",
	userApiKey = "user-api-key-resolv-risk-plataform",
	mode = "user-mode-resolv-risk-plataform",
}
